module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-box tilebox-three"
  }, [_c('week-timetable', {
    attrs: {
      "events": _vm.getEvents(),
      "day-range": [1, 2, 3, 4, 5]
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "table-cell-hover-no-opacity",
          style: ({
            backgroundColor: _vm.getCellColor(props.event),
            textAlign: 'center',
            width: '100%',
            height: '100%',
            opacity: props.event.meta.week_day === _vm.actualWeekDay && props.event.meta.slot_id === _vm.actualTimeSlot ? 1 : 0.5
          })
        }, [_vm._v("\n        " + _vm._s(_vm.getCellContent(props.event)) + "\n      ")])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-10 text-center"
  }, _vm._l((_vm.callTypes), function(callType) {
    return _c('span', [_c('span', {
      staticClass: "label label-pill",
      style: ({
        backgroundColor: callType.planning_color
      })
    }, [_vm._v("Type d'appel : " + _vm._s(callType.name))]), _vm._v(" \n    ")])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cd6a6c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents/Main/Dashboard/PlanningWidget.vue
// module id = 689
// module chunks = 1